function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.plus0{fill:#FF0082;}\n");
var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path",
  className: "plus0",
  d: "M6.56,6.56h4.12h0.85c0.13,0,0.23-0.1,0.23-0.23V5.43c0-0.13-0.1-0.23-0.23-0.23l-4.97,0l0-4.97 C6.56,0.1,6.46,0,6.33,0L5.43,0C5.3,0,5.2,0.1,5.2,0.23V5.2l-4.97,0C0.1,5.2,0,5.3,0,5.43v0.91c0,0.13,0.1,0.23,0.23,0.23l4.97,0 v4.12v0.85c0,0.13,0.1,0.23,0.23,0.23h0.91c0.13,0,0.23-0.1,0.23-0.23V6.56z"
});
var SvgPlus = function SvgPlus(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 11.76 11.76",
    style: {
      enableBackground: "new 0 0 11.76 11.76"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plus.c6205fbb.svg";
export { ForwardRef as ReactComponent };